module.exports = __webpack_public_path__ + "img/logoBlack.2cde7e80.svg";